import { createAction, createReducer } from '@reduxjs/toolkit';
import { CSVFile, DataModelState } from './dataModelTypes';

export const clearDataModel = createAction('CLEAR_DATA_MODEL');
export const setDataModel = createAction<DataModelState>('SET_DATA_MODEL');
export const setDataModelParamCount = createAction<number | undefined>('SET_DATA_MODEL_PARAM_COUNT');
export const setDataModelFiles = createAction<CSVFile[]>('SET_DATA_MODEL_FILES');
export const setDataModelSharedFolders = createAction<string[]>('SET_DATA_MODEL_SHARED_FOLDERS');
export const setIsLoadingDataModel = createAction<boolean>('SET_IS_LOADING_DATA_MODEL');
export const setIsErrorLoadingModel = createAction<boolean>('SET_IS_ERROR_LOADING_DATA_MODEL');
export const setGlobalEntity = createAction<any>('SET_GLOBAL_ENTITY');
export const setGlobalEntityAssetId = createAction<any>('SET_GLOBAL_ENTITY_ASSET_ID');
export const setServiceIdForDataModel = createAction<number>('SET_SERVICE_ID_FOR_DATA_MODEL');

const initialState: DataModelState = {
  dataModel: undefined,
  serviceId: 0,
  isLinked: false,
  paramCount: undefined,
  files: undefined,
  sharedFolders: undefined,
  isLoading: false,
  isError: false,
  globalEntity: undefined,
  globalEntityAssetId: undefined,
};

export const dataModelReducer = createReducer(initialState, builder => {
  builder.addCase(clearDataModel, state => {
    state.dataModel = undefined;
    state.serviceId = 0;
    state.isLinked = false;
    state.paramCount = undefined;
    state.sharedFolders = undefined;
    state.isLoading = false;
    state.isError = false;
    state.globalEntity = undefined;
    state.globalEntityAssetId = undefined;
  });
  builder.addCase(setDataModel, (state, action) => {
    state.dataModel = action.payload.dataModel;
    state.serviceId = action.payload.serviceId;
    state.isLinked = action.payload.isLinked;
    state.paramCount = action.payload.paramCount;
    state.isLoading = action.payload.isLoading;
    state.files = action.payload.files;
    state.sharedFolders = action.payload.sharedFolders;
    state.isError = false;
  });
  builder.addCase(setServiceIdForDataModel, (state, action) => {
    state.serviceId = action.payload;
  });
  builder.addCase(setDataModelParamCount, (state, action) => {
    state.paramCount = action.payload;
  });
  builder.addCase(setDataModelFiles, (state, action) => {
    state.files = action.payload;
  });
  builder.addCase(setIsLoadingDataModel, (state, action) => {
    state.isLoading = action.payload;
  });
  builder.addCase(setDataModelSharedFolders, (state, action) => {
    state.sharedFolders = action.payload;
  });
  builder.addCase(setIsErrorLoadingModel, (state, action) => {
    state.isError = action.payload;
  });
  builder.addCase(setGlobalEntity, (state, action) => {
    state.globalEntity = action.payload;
  });
  builder.addCase(setGlobalEntityAssetId, (state, action) => {
    state.globalEntityAssetId = action.payload;
  });
});
